import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Button, Card } from 'react-bootstrap';
import { useErrorBoundary } from 'react-error-boundary';
import { toast } from 'react-toastify';
import { startLoading, stopLoading } from '../../../../store/loadingReducer';
import { toastConfig } from '../../../utils';
import CustomTextBox from '../../CustomTextBox';
import api from '../../../api/CallMusicApi';
import Axios from 'axios';

interface Props {
  setSearchResult: (result: any[]) => void;
}

const MusicSakuhinSearchBox: React.FC<Props> = ({ setSearchResult }) => {
  const [searchKyoku, setSearchKyoku] = useState<string>('');
  const [searchArtist, setSearchArtist] = useState<string>('');
  const dispatch = useDispatch();
  const { showBoundary } = useErrorBoundary();

  const onClickSearch = async () => {
    try {
      dispatch(startLoading());
      setSearchResult([]);
      const result = await api.getSakuhin(searchKyoku, searchArtist);
      if (!result.length) {
        toast.error('検索条件に該当するアルバム・シングルは見つかりませんでした。', toastConfig());
        return;
      }
      toast.success(result.length < 500 ? `${result.length}件該当しました。` : '500件以上該当しました。500件までを表示しています。', toastConfig());
      setSearchResult(result);
    } catch (e: any) {
      if (!Axios.isAxiosError(e)) showBoundary(e);
      if (e.response.status === 400) {
        toast.error(e.response.data, toastConfig());
      } else {
        showBoundary(e);
      }
    } finally {
      dispatch(stopLoading());
    }
  };

  return (
    <Row style={{ margin: '10px', marginTop: '10px' }}>
      <Col md={1}>
        <div style={{ alignItems: 'center', display: 'flex', flexFlow: 'column' }}>
          <img src={`${process.env.PUBLIC_URL}/images/musicWidget/searchOnpu.png`} className="w-100 mt-1" />
          <img src={`${process.env.PUBLIC_URL}/images/musicWidget/flow.png`} className="w-50 mt-1" />
        </div>
      </Col>
      <Col md={7}>
        <Card style={{ padding: '10px', backgroundColor: '#E3F1FF' }}>
          <CustomTextBox label="楽曲名" value={searchKyoku} onChange={(e) => setSearchKyoku(e.target.value)} style={{ fontSize: '14px' }} />
          <CustomTextBox
            label="アーティスト名又は作家名"
            value={searchArtist}
            onChange={(e) => setSearchArtist(e.target.value)}
            style={{ fontSize: '14px', marginTop: '-10px' }}
          />
          <Row>
            <Col md={{ span: 3, offset: 9 }}>
              <Button variant="primary" type="button" as="input" value="検索" onClick={onClickSearch} style={{ width: '100%' }} />
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default MusicSakuhinSearchBox;
